import { removeErrorStackInitiator } from '@app/utils/removeStackInitiator'

import type { Location } from './types'

export class NotFoundError extends Error {
  location!: Location

  static create(location: Location) {
    const err = new NotFoundError(`Not found: ${location.pathname}`)
    err.location = location
    removeErrorStackInitiator(err)
    return err
  }
}
